import { useCallback, useEffect, useRef, useState } from 'react';
import { api } from '../../lib/api.js';

const EMPTY = {
  orgs: [],
  months: [],
  sources: { voice_calls: { configured: false } },
};

export function useClientUsage(clientId) {
  const [usage, setUsage] = useState(EMPTY);
  const [loading, setLoading] = useState(true);
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState('');
  const gen = useRef(0);

  const load = useCallback(
    async ({ rethrow }) => {
      const mine = (gen.current += 1);
      setLoading(true);
      try {
        const data = await api(`/clients/${clientId}/usage`);
        if (mine !== gen.current) return;
        setUsage({ ...EMPTY, ...data });
        setLoaded(true);
        setError('');
      } catch (err) {
        if (mine === gen.current) setError(err.message);
        if (rethrow) throw err;
      } finally {
        if (mine === gen.current) setLoading(false);
      }
    },
    [clientId],
  );

  const reload = useCallback(() => load({ rethrow: true }), [load]);

  useEffect(() => {
    setUsage(EMPTY);
    setLoaded(false);
    load({ rethrow: false }).catch(() => {});
    return () => {
      gen.current += 1;
    };
  }, [clientId, load]);

  return { usage, loading, loaded, error, reload };
}
